/**
 * The Nitin Online Book game catalogue.
 * Artwork is generated locally (scripts/generate-art.mjs) so every tile is
 * on-brand and loads instantly.
 */

const art = (slug) => `/assets/images/gen/game-${slug}.svg`;

export const GAMES = [{
        id: 1,
        slug: 'teen-patti',
        name: 'Teen Patti Gold',
        category: 'Live Casino',
        tone: 'gold',
        image: art('teen-patti'),
        tagline: 'The three-card classic, dealt live from a studio table',
        description: "India's favourite card game with real dealers, real players and traditional rules — side bets, boot limits and blind play all included.",
        fullDescription: "Teen Patti Gold runs around the clock on Nitin Online Book with studio dealers, HD streams and table chat. Blind, seen, side-show — every classic rule is on the table, and every hand is dealt from a certified shoe you can audit. New players get a walkthrough on WhatsApp before their first boot.",
        minBet: 10,
        maxBet: 500000,
        maxWin: 1000000,
        rating: 4.9,
        playerCount: 2847,
        rtp: '97.4%',
        isLive: true,
        isPopular: true,
        badge: 'hot',
        features: ['Live dealers', 'Side show', 'Table chat', 'Private tables'],
        recentWinner: { name: 'Rajesh K.', amount: 125000 },
        rules: [
            'Every player is dealt three cards face down',
            'Play blind for half stake or see your cards and bet full',
            'Call a side show to compare hands with the player before you',
            'Highest hand at showdown takes the pot — trail beats everything',
        ],
        strategies: [
            { title: 'Play blind early', description: 'Blind rounds cost half. Use the first three rounds to read the table before you pay full price.' },
            { title: 'Size the boot', description: 'Keep your boot under 2% of your bankroll so one cold table never ends the night.' },
        ],
    },
    {
        id: 2,
        slug: 'andar-bahar',
        name: 'Andar Bahar Royal',
        category: 'Live Casino',
        tone: 'crimson',
        image: art('andar-bahar'),
        tagline: 'One card, one side, one heartbeat',
        description: 'The fastest traditional Indian game on the floor — pick Andar or Bahar and get your result in seconds with near coin-flip odds.',
        fullDescription: 'Andar Bahar Royal deals a joker card, then alternates left and right until the match appears. Rounds finish in under 30 seconds, the house edge is among the lowest on the platform, and our royal tables add streak bonuses for consecutive wins.',
        minBet: 5,
        maxBet: 250000,
        maxWin: 500000,
        rating: 4.8,
        playerCount: 1923,
        rtp: '97.8%',
        isLive: true,
        isPopular: true,
        badge: 'trending',
        features: ['30-second rounds', 'Streak bonus', 'Low house edge', 'Mobile first'],
        recentWinner: { name: 'Priya S.', amount: 78000 },
        rules: [
            'The dealer reveals one joker card',
            'Back Andar (left) or Bahar (right)',
            'Cards are dealt alternately to both sides',
            'The side that matches the joker pays out instantly',
        ],
    },
    {
        id: 3,
        slug: 'roulette',
        name: 'Lightning Roulette',
        category: 'Live Casino',
        tone: 'violet',
        image: art('roulette'),
        tagline: 'European wheel with multiplier strikes up to 500x',
        description: 'Single-zero European roulette with lightning numbers that turn a straight-up bet into a 500x payout on any spin.',
        fullDescription: 'A single-zero wheel keeps the odds player-friendly, then lightning strikes electrify up to five numbers each round with multipliers from 50x to 500x. Racetrack betting, neighbour bets and full statistics are built into the table.',
        minBet: 20,
        maxBet: 400000,
        maxWin: 2000000,
        rating: 4.8,
        playerCount: 1456,
        rtp: '97.3%',
        isLive: true,
        isPopular: true,
        badge: 'new',
        features: ['500x multipliers', 'Racetrack bets', 'Hot & cold stats', 'VIP limits'],
        recentWinner: { name: 'Meera J.', amount: 268000 },
    },
    {
        id: 4,
        slug: 'dragon-tiger',
        name: 'Dragon Tiger',
        category: 'Live Casino',
        tone: 'amber',
        image: art('dragon-tiger'),
        tagline: 'Two cards. Twenty seconds. Pure nerve.',
        description: 'The simplest duel in the palace — back the Dragon or the Tiger, highest card wins, results in twenty seconds flat.',
        fullDescription: 'Dragon Tiger strips baccarat down to a single card per side. Bet Dragon, Tiger or Tie, watch the deal, collect. Suit bets and big-small side markets give experienced players extra angles without slowing the pace.',
        minBet: 15,
        maxBet: 300000,
        maxWin: 600000,
        rating: 4.7,
        playerCount: 1187,
        rtp: '96.7%',
        isLive: true,
        isPopular: true,
        badge: 'hot',
        features: ['20-second rounds', 'Suit side bets', 'Roadmap trends', 'Auto-play'],
        recentWinner: { name: 'Imran A.', amount: 210000 },
    },
    {
        id: 5,
        slug: 'blackjack',
        name: 'Blackjack Premium',
        category: 'Live Casino',
        tone: 'emerald',
        image: art('blackjack'),
        tagline: 'Where strategy actually pays',
        description: 'Classic 21 with professional dealers, split, double down, insurance and the lowest house edge on the platform.',
        fullDescription: 'Blackjack Premium pays 3:2, stands on soft 17 and allows splitting up to three hands. Our WhatsApp desk sends you a free basic-strategy chart on request — used correctly it keeps the house edge under half a percent.',
        minBet: 25,
        maxBet: 350000,
        maxWin: 750000,
        rating: 4.8,
        playerCount: 892,
        rtp: '99.5%',
        isLive: true,
        isPopular: false,
        badge: 'classic',
        features: ['3:2 blackjack', 'Split & double', 'Perfect pairs', 'Strategy chart'],
        recentWinner: { name: 'Vikram R.', amount: 96000 },
    },
    {
        id: 6,
        slug: 'baccarat',
        name: 'Baccarat VIP',
        category: 'Live Casino',
        tone: 'sapphire',
        image: art('baccarat'),
        tagline: 'The high-roller room, open to you',
        description: 'Squeeze tables, big-road scorecards and limits built for serious bankrolls — with a dedicated manager on WhatsApp.',
        fullDescription: 'Baccarat VIP runs speed and squeeze variants with commission-free options. Every VIP seat comes with a dedicated relationship manager, priority withdrawals and monthly cashback on turnover.',
        minBet: 100,
        maxBet: 1000000,
        maxWin: 2000000,
        rating: 4.9,
        playerCount: 543,
        rtp: '98.9%',
        isLive: true,
        isPopular: false,
        badge: 'vip',
        features: ['Commission free', 'Squeeze tables', 'Dedicated manager', 'Priority payout'],
        recentWinner: { name: 'Sanjay D.', amount: 540000 },
    },
    {
        id: 7,
        slug: 'cricket-exchange',
        name: 'Cricket Exchange',
        category: 'Sports Betting',
        tone: 'emerald',
        image: art('cricket-exchange'),
        tagline: 'Back, lay and cash out every ball',
        description: 'Live cricket markets across IPL, internationals and domestic T20 with ball-by-ball odds and instant cash out.',
        fullDescription: 'Trade cricket like a market: back or lay any outcome, hedge mid-innings and cash out whenever the price suits you. Session markets, fancy markets and player props update ball by ball with sub-second latency.',
        minBet: 50,
        maxBet: 800000,
        maxWin: 5000000,
        rating: 4.9,
        playerCount: 3156,
        rtp: 'Exchange odds',
        isLive: true,
        isPopular: true,
        badge: 'hot',
        features: ['Back & lay', 'Session markets', 'One-tap cash out', 'Live scorecard'],
        recentWinner: { name: 'Amit P.', amount: 375000 },
    },
    {
        id: 8,
        slug: 'football-book',
        name: 'Football Book',
        category: 'Sports Betting',
        tone: 'sapphire',
        image: art('football-book'),
        tagline: 'Every league, every minute',
        description: 'Premier League, Champions League, La Liga and ISL with in-play markets, accumulators and early payout offers.',
        fullDescription: 'Over 200 markets per match across the world&rsquo;s biggest competitions. Build accumulators, use bet-builder combinations, and take early payout when your team goes two goals clear.',
        minBet: 20,
        maxBet: 500000,
        maxWin: 3000000,
        rating: 4.7,
        playerCount: 1089,
        rtp: 'Exchange odds',
        isLive: true,
        isPopular: true,
        badge: 'trending',
        features: ['200+ markets', 'Bet builder', 'Early payout', 'Live stats'],
        recentWinner: { name: 'Karan T.', amount: 142000 },
    },
    {
        id: 9,
        slug: 'slots',
        name: 'Bollywood Mega Slots',
        category: 'Slots',
        tone: 'amber',
        image: art('slots'),
        tagline: 'Reels with a soundtrack you already know',
        description: 'Bollywood-themed reels with free spins, expanding wilds and a progressive jackpot that resets at ₹10 lakh.',
        fullDescription: 'A hand-picked library of Bollywood and Indian-themed slots with cascading reels, hold-and-win bonuses and a shared progressive pot. Spin from ₹1 — the jackpot can drop on any stake.',
        minBet: 1,
        maxBet: 20000,
        maxWin: 10000000,
        rating: 4.6,
        playerCount: 1567,
        rtp: '96.2%',
        isLive: false,
        isPopular: true,
        badge: 'jackpot',
        features: ['Progressive pot', 'Free spins', 'Hold & win', 'Buy bonus'],
        recentWinner: { name: 'Sneha M.', amount: 845000 },
    },
    {
        id: 10,
        slug: 'crash',
        name: 'Rocket Crash',
        category: 'Instant Win',
        tone: 'crimson',
        image: art('crash'),
        tagline: 'Cash out before the rocket goes',
        description: 'A rising multiplier, a nerve-testing exit and provably fair maths you can verify after every single round.',
        fullDescription: 'The multiplier climbs from 1.00x — cash out any time before the crash. Auto cash-out, dual bets and a public verification hash for every round make this the most transparent game on the platform.',
        minBet: 10,
        maxBet: 100000,
        maxWin: 5000000,
        rating: 4.7,
        playerCount: 2210,
        rtp: '97.0%',
        isLive: true,
        isPopular: true,
        badge: 'new',
        features: ['Provably fair', 'Auto cash-out', 'Dual bets', 'Live leaderboard'],
        recentWinner: { name: 'Dev S.', amount: 318000 },
    },
    {
        id: 11,
        slug: 'lightning-dice',
        name: 'Lightning Dice',
        category: 'Instant Win',
        tone: 'violet',
        image: art('lightning-dice'),
        tagline: 'Three dice, one tower, up to 1000x',
        description: 'Call the total of three dice down the lightning tower and let random multipliers boost the payout.',
        fullDescription: 'Dice tumble down an illuminated tower while lightning multipliers hit one to three totals each round. Simple to learn, and the multiplier layer keeps veterans coming back.',
        minBet: 10,
        maxBet: 150000,
        maxWin: 1500000,
        rating: 4.6,
        playerCount: 764,
        rtp: '96.2%',
        isLive: true,
        isPopular: false,
        badge: 'classic',
        features: ['Up to 1000x', 'Live host', 'Statistics panel', 'Quick bets'],
        recentWinner: { name: 'Harsh P.', amount: 88000 },
    },
    {
        id: 12,
        slug: 'wheel-fortune',
        name: 'Royal Wheel Draw',
        category: 'Lottery',
        tone: 'gold',
        image: art('wheel-fortune'),
        tagline: 'Daily draws, life-changing tiers',
        description: 'Daily and weekly draws with five prize tiers, transparent RNG audits and results published to every player.',
        fullDescription: 'Buy a ticket from ₹10 and enter the daily wheel. Five prize tiers mean far more winners than a single-jackpot draw, and every result is signed and published so anyone can verify it.',
        minBet: 10,
        maxBet: 50000,
        maxWin: 10000000,
        rating: 4.5,
        playerCount: 2234,
        rtp: 'Published draws',
        isLive: false,
        isPopular: true,
        badge: 'jackpot',
        features: ['Daily draw', '5 prize tiers', 'Audited RNG', 'Auto numbers'],
        recentWinner: { name: 'Anjali R.', amount: 1200000 },
    },
];

export const CATEGORIES = [
    { id: 'all', name: 'All Games', icon: 'LayoutGrid' },
    { id: 'live-casino', name: 'Live Casino', icon: 'Spade' },
    { id: 'sports-betting', name: 'Sports Betting', icon: 'Trophy' },
    { id: 'instant-win', name: 'Instant Win', icon: 'Zap' },
    { id: 'slots', name: 'Slots', icon: 'Cherry' },
    { id: 'lottery', name: 'Lottery', icon: 'Ticket' },
];

export const BADGES = {
    hot: { label: 'HOT', icon: 'Flame', className: 'from-[#FF6B3D] to-[#FF3D71]' },
    trending: { label: 'TRENDING', icon: 'TrendingUp', className: 'from-[#37E39B] to-[#12924A]' },
    new: { label: 'NEW', icon: 'Sparkles', className: 'from-[#69A8FF] to-[#3B5BDB]' },
    vip: { label: 'VIP', icon: 'Crown', className: 'from-[#FFF0B8] to-[#C4901A]' },
    classic: { label: 'CLASSIC', icon: 'Star', className: 'from-[#B98CFF] to-[#6D28D9]' },
    jackpot: { label: 'JACKPOT', icon: 'Gem', className: 'from-[#FFB454] to-[#FF3D71]' },
};

export const formatINR = (amount) => {
    if (amount >= 10000000) return `₹${(amount / 10000000).toFixed(amount % 10000000 === 0 ? 0 : 1)}Cr`;
    if (amount >= 100000) return `₹${(amount / 100000).toFixed(amount % 100000 === 0 ? 0 : 1)}L`;
    if (amount >= 1000) return `₹${(amount / 1000).toFixed(amount % 1000 === 0 ? 0 : 1)}K`;
    return `₹${amount.toLocaleString('en-IN')}`;
};

export default GAMES;